export default __webpack_public_path__ + "static/media/pioneer_banner_homepage.6648d771.png";